var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGold(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 -0.5 12 12",
    shapeRendering: "crispEdges",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    d: "M2 1h8M1 2h1m4 0h1m3 0h1M0 3h1m6 0h1m3 0h1M0 4h1m6 0h1m3 0h1M0 5h1m6 0h1m3 0h1M0 6h1m6 0h1m3 0h1M0 7h1m6 0h1m2 0h1M0 8h1m6 0h3M1 9h1m4 0h1m-5 1h4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#f7c42a",
    d: "M2 2h4m1 0h3M1 3h6m1 0h3M2 4h4m2 0h2M3 5h1M3 7h1M3 9h1"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "#f7971b",
    d: "M1 4h1m4 0h1m3 0h1M2 5h1m1 0h2m2 0h2M1 6h1m4 0h1m3 0h1M2 7h1m1 0h2m2 0h2M1 8h1m4 0h1M2 9h1m1 0h2"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    stroke: "#ce5906",
    d: "M1 5h1m4 0h1m3 0h1M2 6h4m2 0h2M1 7h1m4 0h1M2 8h4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGold);
export default __webpack_public_path__ + "static/media/gold.d6ba9ca5841f0448ac46f744b279c5f9.svg";
export { ForwardRef as ReactComponent };